import React, { useMemo } from 'react';
import { richTextToHtml, sanitizeHtml } from './richText';
import './editor.css';

export type RichTextViewProps = {
  /** HTML, legacy Editor.js JSON or plain text. */
  value: string | null | undefined;
  className?: string;
};

/** Read-only rendering of stored rich text. Everything goes through the sanitiser first. */
const RichTextView: React.FC<RichTextViewProps> = ({ value, className }) => {
  const html = useMemo(() => sanitizeHtml(richTextToHtml(value)), [value]);

  return (
    <div
      className={className ? `rich-text ${className}` : 'rich-text'}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichTextView;
